import React from "react";
import clsx from "clsx";
import useDelayedValue from "hooks/useDelayedValue";
import styles from "./Gate.module.css";

type GateProps = {
    position: number;
    delay: number;
    processedId?: number;
};

const Gate = ({ position, delay, processedId }: GateProps) => {
    const [processing, setProcessing] = React.useState(true);
    const delayedProcessedId = useDelayedValue(processedId, delay, undefined);

    React.useEffect(() => {
        if (!delayedProcessedId) return;

        let raf = requestAnimationFrame(() => {
            setProcessing(false);
            raf = requestAnimationFrame(() => {
                setProcessing(true);
            });
        });
        return () => cancelAnimationFrame(raf);
    }, [delayedProcessedId]);

    return (
        <div
            className={clsx(styles.root, {
                [styles.invisible]: position < 0,
            })}
            style={{
                transform: `translateX(calc(-60px * ${position}))`,
            }}
        >
            <div
                className={clsx(styles.fill, {
                    [styles.processing]: processing,
                })}
            />
        </div>
    );
};

export default Gate;
